/**
 * Country code to flag emoji mapping + country names
 */

const FLAGS = {};

/**
 * Convert ISO 3166-1 alpha-2 country code to flag emoji.
 * Works by converting each letter to its regional indicator symbol.
 */
export function countryCodeToFlag(code) {
  if (!code || code.length !== 2) return '🌍';
  const upper = code.toUpperCase();
  return String.fromCodePoint(
    ...upper.split('').map(c => 0x1F1E6 + c.charCodeAt(0) - 65)
  );
}

/**
 * Debounce function — delays execution until user stops acting
 */
export function debounce(fn, ms) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), ms);
  };
}

/**
 * Throttle function — limits execution to once per interval
 */
export function throttle(fn, ms) {
  let last = 0;
  return (...args) => {
    const now = Date.now();
    if (now - last >= ms) {
      last = now;
      fn(...args);
    }
  };
}

/**
 * Format bitrate for display
 */
export function formatBitrate(kbps) {
  if (!kbps) return '';
  return `${kbps} kbps`;
}

/**
 * Generate a slug from a station name
 */
export function slugify(text) {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
}
